import React from 'react';
import { IRouteDetailsImage } from '../../../../../sp-types/routeDetailsType';
import { deleteFile, uploadFile } from '../../../../../sp-firebase/storageFB';
import DocUploadPanel from '../../../../../components/UI-Elements/FileUpload/DocUploadPanel/DocUploadPanel';

export const InputRouteDetailsImage: React.FC<IRouteDetailsImage> = ({ imageUrl, update = () => {}, routeId }) => {
  const onUploadNewDocument = async (documentToAdd: any) => {
    const uploadedFileUrl = await uploadFile(documentToAdd[0], `Routes/${routeId}`);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    uploadedFileUrl && update({ imageUrl: uploadedFileUrl, routeId });
  };

  const onDeleteDoc = async () => {
    if (imageUrl) {
      await deleteFile(imageUrl);
      update({ imageUrl: '', routeId });
    }
  };

  return (
    <div>
      <DocUploadPanel
        onDeleteDocument={onDeleteDoc}
        onUploadNewDocument={onUploadNewDocument}
        uploadedDocumentPath={imageUrl}
      />
    </div>
  );
};
